/**
 * @generated SignedSource<<cbb8da0528e36bd34371b0889970d310>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectActionsWithCapabilitiesQuery$variables = {
  containerId: string;
};
export type ProjectActionsWithCapabilitiesQuery$data = {
  readonly projects_capabilities_extension: {
    readonly canCreateProject: boolean | null | undefined;
  } | null | undefined;
};
export type ProjectActionsWithCapabilitiesQuery = {
  response: ProjectActionsWithCapabilitiesQuery$data;
  variables: ProjectActionsWithCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  }
],
v1 = [
  {
    "kind": "ClientExtension",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities_extension",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectActionsWithCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectActionsWithCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02c0d52d1bd2d0ca59ddc88e76d1f6c5",
    "id": null,
    "metadata": {},
    "name": "ProjectActionsWithCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9b9c3da42e86c8bf115605d7f450ea15";

export default node;
